module.exports = __webpack_public_path__ + "static/media/construction.5237a38b.gif";